<h2 mat-dialog-title>Add Pump</h2>

<mat-tab-group>
    <mat-tab label="Description">
        <div>
            <form [formGroup]="descriptionForm"
                (ngSubmit)="onSubmit(descriptionForm.value, parameters.value,altertNotification.value,  alertParameter.value, dtmuDevice.value)">

                <div class="row col-md-12">


                    <mat-form-field>
                        <mat-label>Transformer Make By</mat-label>
                        <input matInput formControlName="transformerMakeBy" required>

                    </mat-form-field>
                    <span class="error"
                        *ngIf="descriptionForm.controls.transformerMakeBy.touched && descriptionForm.controls.transformerMakeBy.errors?.required">
                        Please Enter Transformer Make By
                    </span>

                </div>
                <div class="row col-md-12">


                    <mat-form-field>
                        <mat-label>Pump Make By</mat-label>
                        <input matInput formControlName="pumpMakeBy" required>

                    </mat-form-field>
                    <span class="error"
                        *ngIf="descriptionForm.controls.pumpMakeBy.touched && descriptionForm.controls.pumpMakeBy.errors?.required">
                        Please Enter Pump Make By
                    </span>

                </div>
                <div class="row col-md-12">
                    <mat-form-field>
                        <mat-label>Serial Number*</mat-label>
                        <input matInput formControlName="serialnumber">
                        <mat-error *ngIf="descriptionForm.controls.serialnumber.hasError('required')">
                            Please Enter Serial Number
                        </mat-error>
                        <mat-error *ngIf="descriptionForm.controls.serialnumber.hasError('duplicateSerial')">
                            Serial Number already exists. Please use a unique ID.
                        </mat-error>
                    </mat-form-field>
                </div>
                


                <div class="row col-md-12">


                    <mat-form-field type="date">
                        <mat-label>Manufacturing Date*</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="manufacturingDate">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>

                    </mat-form-field>
                    <span class=" error"
                        *ngIf="descriptionForm.controls.manufacturingDate.touched && descriptionForm.controls.manufacturingDate.errors?.required">
                        Please Enter Manufacturing Date
                    </span>

                </div>

                <div class="row col-md-12">
                    <mat-form-field type="date">
                        <mat-label>Installation Date*</mat-label>
                        <input matInput [matDatepicker]="picker1" formControlName="installationDate">
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>

                    </mat-form-field>
                    <span class=" error"
                        *ngIf="descriptionForm.controls.installationDate.touched && descriptionForm.controls.installationDate.errors?.required">
                        Please Enter Installation Date
                    </span>
                </div>




            </form>

        </div>
        <br>
    </mat-tab>

    <mat-tab *ngIf="userId == 1" label="Parameters">

        <form [formGroup]="parameters">

            <mat-card class="example-card">
                <mat-card-header>
                    <mat-card-title>
                        <h4>Parameters</h4>
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="scrollbar scrollbar-primary">
                        <div class="col-md-12" id="test">

                            <div class="row">
                                <div class="col-md-6">
                                    <label>Pump Current</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-slide-toggle formControlName="pumpcurrent"></mat-slide-toggle>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <label>Motor DE Temperature</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-slide-toggle formControlName="motordetemp"></mat-slide-toggle>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <label>Motor NDE Temperature</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-slide-toggle formControlName="motorndetemp"></mat-slide-toggle>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <label>Motor R Phase Temperature</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-slide-toggle formControlName="motorrphasetemp"></mat-slide-toggle>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <label>Motor Y Phase Temperature</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-slide-toggle formControlName="motoryphasetemp"></mat-slide-toggle>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <label>Motor B Phase Temperature</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-slide-toggle formControlName="motorbphasetemp"></mat-slide-toggle>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <label>Sump Level</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-slide-toggle formControlName="sumplevel"></mat-slide-toggle>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <label>Water Level</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-slide-toggle formControlName="waterlevel"></mat-slide-toggle>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <label>Pump On Feedback</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-slide-toggle formControlName="pumponfeedback"></mat-slide-toggle>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <label>Pump Discharge Pressure Low</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-slide-toggle formControlName="pumpdischargelow"></mat-slide-toggle>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <label>Motor Overload</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-slide-toggle formControlName="motoroverload"></mat-slide-toggle>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <label>Lighting Transformer ON Feedback</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-slide-toggle formControlName="lightingonfeedback"></mat-slide-toggle>
                                </div>
                            </div>


                            <div class="row">
                                <div class="col-md-6">
                                    <label>AB Switch ON Feedback</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-slide-toggle formControlName="abswitchonfeedback"></mat-slide-toggle>
                                </div>
                            </div>

                        </div>
                    </div>
                </mat-card-content>
            </mat-card>


        </form>
    </mat-tab>


    <mat-tab label="Alert Parameters">
        <form [formGroup]="alertParameter">
           
            <h4>Alert Parameters</h4>
            <div class="row">
                <table>
                    <tr>
                        <td>
                            <mat-form-field class="form-element" style="margin-left: 15%;">

                                <mat-label>Frequency</mat-label>
                                <input type="number" matInput
                                    (keyup)="checkFrequency($event,'pumpcurrentfrequency','pumpcurrenttime')"
                                    formControlName="pumpcurrentfrequency">

                            </mat-form-field>
                            <span class="error"
                                *ngIf="frequencyMsg && frequencyMsg.pumpcurrentfrequency && frequencyMsg.pumpcurrentfrequency.length > 0">
                                {{frequencyMsg.pumpcurrentfrequency}}
                            </span>


                        </td>
                        <td>
                            <mat-label>Minutes</mat-label>
                        </td>
                    </tr>

                    <tr>
                        <td>

                            <mat-form-field style="margin-left: 15%;">

                                <mat-label>Pump Current ></mat-label>
                                <input type="number" matInput formControlName="pumpcurrent">

                            </mat-form-field>

                            <span class=" error"
                                *ngIf="alertParameter.controls.pumpcurrent.touched && alertParameter.controls.pumpcurrent.errors?.required">
                                Please Enter value
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName="pumpcurrentemail"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName="pumpcurrentsms"></mat-slide-toggle>
                        </td>

                        <td>
                            <mat-form-field class="form-element" hidden=true>
                                <mat-label>Time</mat-label>
                                <mat-select formControlName="pumpcurrenttime">
                                    <mat-option *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>
                    <tr>
                        <td>

                            <mat-form-field style="margin-left: 15%;">

                                <mat-label>Motor DE Temperature ></mat-label>
                                <input type="number" matInput formControlName="motordetemperature">

                            </mat-form-field>

                            <span class=" error"
                                *ngIf="alertParameter.controls.motordetemperature.touched && alertParameter.controls.motordetemperature.errors?.required">
                                Please Enter values
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName="motordetemperatureemail"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName="motordetemperaturesms"></mat-slide-toggle>
                        </td>

                        <td>
                            <mat-form-field class="form-element" hidden=true>
                                <mat-label>Time</mat-label>
                                <mat-select formControlName="motordetemperaturetime">
                                    <mat-option *ngFor="let freq101 of Frequency" [value]="freq101">
                                        {{freq101}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>

                    <tr>
                        <td>

                            <mat-form-field style="margin-left: 15%;">

                                <mat-label>Motor NDE Temperature ></mat-label>
                                <input type="number" matInput formControlName="motorndetemperature">

                            </mat-form-field>

                            <span class=" error"
                                *ngIf="alertParameter.controls.motorndetemperature.touched && alertParameter.controls.motorndetemperature.errors?.required">
                                Please Enter value
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName="motorndetemperatureemail"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName="motorndetemperaturesms"></mat-slide-toggle>
                        </td>

                        <td>
                            <mat-form-field class="form-element" hidden=true>
                                <mat-label>Time</mat-label>
                                <mat-select formControlName="motorndetemperaturetime">
                                    <mat-option *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>

                    <tr>
                        <td>

                            <mat-form-field style="margin-left: 15%;">

                                <mat-label>Motor RPhase Temperature ></mat-label>
                                <input type="number" matInput formControlName="motorrphasetemperature">

                            </mat-form-field>

                            <span class=" error"
                                *ngIf="alertParameter.controls.motorrphasetemperature.touched && alertParameter.controls.motorrphasetemperature.errors?.required">
                                Please Enter value
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName="motorrphasetemperatureemail"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName="motorrphasetemperaturesms"></mat-slide-toggle>
                        </td>

                        <td>
                            <mat-form-field class="form-element" hidden=true>
                                <mat-label>Time</mat-label>
                                <mat-select formControlName="motorrphasetemperaturetime">
                                    <mat-option *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>

                    <tr>
                        <td>

                            <mat-form-field style="margin-left: 15%;">

                                <mat-label>Motor YPhase Temperature ></mat-label>
                                <input type="number" matInput formControlName="motoryphasetemperature">

                            </mat-form-field>

                            <span class=" error"
                                *ngIf="alertParameter.controls.motoryphasetemperature.touched && alertParameter.controls.motoryphasetemperature.errors?.required">
                                Please Enter value
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName="motoryphasetemperatureemail"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName="motoryphasetemperaturesms"></mat-slide-toggle>
                        </td>

                        <td>
                            <mat-form-field class="form-element" hidden=true>
                                <mat-label>Time</mat-label>
                                <mat-select formControlName="motoryphasetemperaturetime">
                                    <mat-option *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>

                    <tr>
                        <td>

                            <mat-form-field style="margin-left: 15%;">

                                <mat-label>Motor BPhase Temperature ></mat-label>
                                <input type="number" matInput formControlName="motorbphasetemperature">

                            </mat-form-field>

                            <span class=" error"
                                *ngIf="alertParameter.controls.motorbphasetemperature.touched && alertParameter.controls.motorbphasetemperature.errors?.required">
                                Please Enter value
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName="motorbphasetemperatureemail"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName="motorbphasetemperaturesms"></mat-slide-toggle>
                        </td>

                        <td>
                            <mat-form-field class="form-element" hidden=true>
                                <mat-label>Time</mat-label>
                                <mat-select formControlName="motorbphasetemperaturetime">
                                    <mat-option *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>

                    <tr>
                        <td>

                            <mat-form-field style="margin-left: 15%;">

                                <mat-label>Sump Level ></mat-label>
                                <input type="number" matInput formControlName="sumpllevel">

                            </mat-form-field>

                            <span class=" error"
                                *ngIf="alertParameter.controls.sumpllevel.touched && alertParameter.controls.sumpllevel.errors?.required">
                                Please Enter value
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName="sumpllevelemail"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName="sumpllevelsms"></mat-slide-toggle>
                        </td>

                        <td>
                            <mat-form-field class="form-element" hidden=true>
                                <mat-label>Time</mat-label>
                                <mat-select formControlName="sumplleveltime">
                                    <mat-option *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>

                    <tr>
                        <td>

                            <mat-form-field style="margin-left: 15%;">

                                <mat-label>Pump On Feedback ></mat-label>
                                <input type="number" matInput formControlName="pumponffeedback">

                            </mat-form-field>

                            <span class=" error"
                                *ngIf="alertParameter.controls.pumponffeedback.touched && alertParameter.controls.pumponffeedback.errors?.required">
                                Please Enter value
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName="pumponffeedbackemail"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName="pumponffeedbacksms"></mat-slide-toggle>
                        </td>

                        <td>
                            <mat-form-field class="form-element" hidden=true>
                                <mat-label>Time</mat-label>
                                <mat-select formControlName="pumponffeedbacktime">
                                    <mat-option *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>

                    <tr>
                        <td>

                            <mat-form-field style="margin-left: 15%;">

                                <mat-label>Pump Discharge Pressure Low ></mat-label>
                                <input type="number" matInput formControlName="pumpdplow">

                            </mat-form-field>

                            <span class=" error"
                                *ngIf="alertParameter.controls.pumpdplow.touched && alertParameter.controls.pumpdplow.errors?.required">
                                Please Enter value
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName="pumpdplowemail"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName="pumpdplowsms"></mat-slide-toggle>
                        </td>

                        <td>
                            <mat-form-field class="form-element" hidden=true>
                                <mat-label>Time</mat-label>
                                <mat-select formControlName="pumpdplowtime">
                                    <mat-option *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>

                    <tr>
                        <td>

                            <mat-form-field style="margin-left: 15%;">

                                <mat-label>Overload ></mat-label>
                                <input type="number" matInput formControlName="overload">

                            </mat-form-field>

                            <span class=" error"
                                *ngIf="alertParameter.controls.overload.touched && alertParameter.controls.overload.errors?.required">
                                Please Enter value
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName="overloademail"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName="overloadsms"></mat-slide-toggle>
                        </td>

                        <td>
                            <mat-form-field class="form-element" hidden=true>
                                <mat-label>Time</mat-label>
                                <mat-select formControlName="overloadtime">
                                    <mat-option *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>

                    <tr>
                        <td>

                            <mat-form-field style="margin-left: 15%;">

                                <mat-label>Lighting Transformer ON Feedback></mat-label>
                                <input type="number" matInput formControlName="lighttonfeedback">

                            </mat-form-field>

                            <span class=" error"
                                *ngIf="alertParameter.controls.lighttonfeedback.touched && alertParameter.controls.lighttonfeedback.errors?.required">
                                Please Enter value
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName="lighttonfeedbackemail"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName="lighttonfeedbacksms"></mat-slide-toggle>
                        </td>

                        <td>
                            <mat-form-field class="form-element" hidden=true>
                                <mat-label>Time</mat-label>
                                <mat-select formControlName="lighttonfeedbacktime">
                                    <mat-option *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>

                    <tr>
                        <td>

                            <mat-form-field style="margin-left: 15%;">

                                <mat-label>AB Switch ON Feedback></mat-label>
                                <input type="number" matInput formControlName="abswitchonfeedback">

                            </mat-form-field>

                            <span class=" error"
                                *ngIf="alertParameter.controls.abswitchonfeedback.touched && alertParameter.controls.abswitchonfeedback.errors?.required">
                                Please Enter value
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName="abswitchonfeedbackemail"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName="abswitchonfeedbacksms"></mat-slide-toggle>
                        </td>

                        <td>
                            <mat-form-field class="form-element" hidden=true>
                                <mat-label>Time</mat-label>
                                <mat-select formControlName="abswitchonfeedbacktime">
                                    <mat-option *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>
                </table>

            </div>
        </form>
    </mat-tab>

    <mat-tab label="Alert Notification">
        <form [formGroup]="altertNotification" class="form">
            <h4>Email for Alarms</h4>
            <div class="row col-md-12">

                <mat-form-field>
                    <mat-label>Email 1</mat-label>
                    <input matInput formControlName="email1" required>

                </mat-form-field>
                <span class=" error"
                    *ngIf="altertNotification.controls.email1.touched && altertNotification.controls.email1.errors?.required">
                    Please Enter Email 1
                </span>
                <span class="error"
                    *ngIf="altertNotification.controls.email1.touched && altertNotification.controls.email1.errors?.email">
                    Please Enter Valid Email
                </span>

            </div>
            <div class="row col-md-12">

                <mat-form-field>
                    <mat-label>Email 2</mat-label>
                    <input matInput formControlName="email2">

                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.email2.touched && altertNotification.controls.email2.errors?.email">
                    Please Enter Valid Email
                </span>
            </div>

            <div class="row col-md-12">

                <mat-form-field>
                    <mat-label>Email 3</mat-label>
                    <input matInput formControlName="email3">

                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.email3.touched && altertNotification.controls.email3.errors?.email">
                    Please Enter Valid Email
                </span>
            </div>

            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Email 4</mat-label>
                    <input matInput formControlName="email4">

                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.email4.touched && altertNotification.controls.email4.errors?.email">
                    Please Enter Valid Email
                </span>
            </div>
            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Email 5</mat-label>
                    <input matInput formControlName="email5">

                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.email5.touched && altertNotification.controls.email5.errors?.email">
                    Please Enter Valid Email
                </span>
            </div>
            <h4>SMS For Alarms</h4>

            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Phone Number 1</mat-label>
                    <input matInput formControlName="phoneNo1" required>
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.phoneNo1.touched && altertNotification.controls.phoneNo1.errors?.required">
                    Please Enter Phone Number 1
                </span>
                <span class="error"
                    *ngIf="altertNotification.controls.phoneNo1.touched && altertNotification.controls.phoneNo1.errors?.pattern">
                    Please Enter Valid Phone Number 1
                </span>
            </div>
            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Phone Number 2</mat-label>
                    <input matInput formControlName="phoneNo2">

                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.phoneNo2.touched && altertNotification.controls.phoneNo2.errors?.pattern">
                    Please Enter Valid Phone Number 2
                </span>
            </div>
            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Phone Number 3</mat-label>
                    <input matInput formControlName="phoneNo3">
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.phoneNo3.touched && altertNotification.controls.phoneNo3.errors?.pattern">
                    Please Enter Valid Phone Number 3
                </span>
            </div>
            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Phone Number 4</mat-label>
                    <input matInput formControlName="phoneNo4">

                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.phoneNo4.touched && altertNotification.controls.phoneNo4.errors?.pattern">
                    Please Enter Valid Phone Number 4
                </span>
            </div>
            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Phone Number 5</mat-label>
                    <input matInput formControlName="phoneNo5">
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.phoneNo5.touched && altertNotification.controls.phoneNo5.errors?.pattern">
                    Please Enter Valid Phone Number 5
                </span>
            </div>
       </form>

    </mat-tab>
    <mat-tab *ngIf="userId == 1" label="DTMU Device">
        <form [formGroup]="dtmuDevice" class="form">
            <h4>New Machine Details</h4>
            <div class="row col-md-12">

                <mat-form-field>
                    <mat-label>Device Category*</mat-label>
                    <mat-select formControlName="deviceCategory">
                        <mat-option *ngFor="let category of deviceMaster.deviceCategory" [value]="category">
                            {{category}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <span class="error"
                    *ngIf="dtmuDevice.controls.deviceCategory.touched && dtmuDevice.controls.deviceCategory.errors?.required">
                    Please Select Device Category
                </span>

            </div>
            <div class="row col-md-12">

                <mat-form-field>
                    <mat-label>Device Model*</mat-label>
                    <mat-select formControlName="deviceModel">
                        <mat-option *ngFor='let model of deviceMaster.deviceModel' [value]="model">
                            {{model}}
                        </mat-option>
                    </mat-select>

                </mat-form-field>

            </div>
            <div class="row col-md-12">

                <mat-form-field>
                    <mat-label>Transformer Id*</mat-label>
                    <mat-select formControlName="transformerid">
                        <mat-option *ngFor='let deviceId of deviceMaster.transformerId' [value]="deviceId">
                            {{deviceId}}
                        </mat-option>
                    </mat-select>

                </mat-form-field>

            </div>

            <div class="row col-md-12">

                <mat-form-field>
                    <mat-label>Heart Beat*</mat-label>
                    <input matInput formControlName="heartBeat">

                </mat-form-field>
                <span class="error"
                    *ngIf="dtmuDevice.controls.heartBeat.touched && dtmuDevice.controls.heartBeat.errors?.required">
                    Please Enter Heart Beat
                </span>
            </div>
            <div class="row col-md-12">

                <mat-form-field>
                    <mat-label>Name*</mat-label>
                    <input matInput formControlName="name">

                </mat-form-field>
                <span class="error"
                    *ngIf="dtmuDevice.controls.name.touched && dtmuDevice.controls.name.errors?.required">
                    Please Enter Name
                </span>

            </div>
            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Passcode</mat-label>
                    <input matInput formControlName="passcode">
                </mat-form-field>
            </div>
            <div class="row col-md-12">
                <mat-label>Remote Controller</mat-label>
                <mat-slide-toggle formControlName="remoteController"></mat-slide-toggle> 

            </div>
            <div class="row col-md-12">
                <mat-label>ON OFF Notify</mat-label>
                <mat-slide-toggle formControlName="onoffNotify"></mat-slide-toggle> 
            </div>

        </form>

    </mat-tab>
</mat-tab-group>
<mat-dialog-actions>
    <div class="form-element">
        <button mat-raised-button color="primary" type="submit"
            (click)="onSubmit(descriptionForm.value, parameters.value, alertParameter.value, altertNotification.value, dtmuDevice.value)"
            class="button">Save</button>
    </div>

    <button class="mat-raised-button" (click)="close('NA')">Close</button>
</mat-dialog-actions>
<br>